/* Afuna Aromatics — About founder sequence controller (Stage 2 WP A, 2026-08-30)

   Progressive enhancement for .aa-founder-seq. Desktop shows all three
   panels via CSS grid and this script only keeps ARIA state tidy. Mobile
   (<=749px) shows one panel at a time; this script wires previous/next
   buttons, position dots, horizontal touch swipe, and ArrowLeft/ArrowRight
   when the viewport is focused, all with circular wrap from last to first
   and first to last. The images are presentational only and are never
   links. No autoplay. Honors prefers-reduced-motion via CSS. */
(function () {
  'use strict';

  function initSequence(root) {
    var track = root.querySelector('.aa-founder-seq__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.aa-founder-seq__slide'));
    var prevBtn = root.querySelector('.aa-founder-seq__nav--prev');
    var nextBtn = root.querySelector('.aa-founder-seq__nav--next');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.aa-founder-seq__dot'));
    var viewport = root.querySelector('.aa-founder-seq__viewport');
    if (!track || slides.length < 2) { return; }

    var count = slides.length;
    var index = 0;
    var mq = window.matchMedia('(max-width: 749px)');

    function mobile() { return mq.matches; }

    function render() {
      if (mobile()) {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
      } else {
        track.style.transform = '';
      }
      slides.forEach(function (slide, i) {
        if (mobile()) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        } else {
          slide.removeAttribute('aria-hidden');
        }
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function go(next) {
      index = (next % count + count) % count;
      render();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { go(index - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { go(index + 1); });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    if (viewport) {
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { go(index - 1); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { go(index + 1); e.preventDefault(); }
      });
    }

    var startX = 0;
    var startY = 0;
    var swiping = false;
    track.addEventListener('touchstart', function (e) {
      if (!mobile()) { return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!swiping || !mobile()) { return; }
      swiping = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        go(dx < 0 ? index + 1 : index - 1);
      }
    }, { passive: true });

    if (mq.addEventListener) {
      mq.addEventListener('change', render);
    } else if (mq.addListener) {
      mq.addListener(render);
    }

    render();
  }

  function init() {
    var roots = document.querySelectorAll('[data-aa-founder-seq]');
    Array.prototype.forEach.call(roots, initSequence);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
